module.exports = __webpack_public_path__ + "img/top_back.233f0b44.png";